/* eslint-disable import/prefer-default-export */
import React from 'react';
import MenuItem from 'Common/Components/ContextMenu/components/MenuItem';
import { useDispatch, useSelector } from 'react-redux';
import { useIntl } from 'react-intl';
import { selectSelected } from 'store/Contextualization/AssetDetail/selectors';
import { showContextMenu, redirectToManageDetail, showBulkUpdateModal } from 'store/Contextualization/AssetDetail/actions';
import {
  FEATURE_COMMENTS, PERMISSION_TYPES
} from 'Hooks/usePermission/permissions';
import { WithPermission } from 'Common/Components/WithPermission';
import { selectAllowedByRole } from 'Hooks/usePermission/selector';
import get from 'lodash/get';
import head from 'lodash/head';
import { CommentsIcon } from './styled';

export const AddComment = () => {
  const dispatch = useDispatch();
  const intl = useIntl();
  const vulnsSelected = useSelector((state) => selectSelected('vulns', state));
  const selectedVulnID = get(head(vulnsSelected), '_id', null);
  const isBulk = vulnsSelected.length > 1;
  const canReadComments = useSelector((state) => selectAllowedByRole(state, FEATURE_COMMENTS, PERMISSION_TYPES.READ));

  if (!canReadComments) return null;
  return (
    <WithPermission permission={ FEATURE_COMMENTS } type={ PERMISSION_TYPES.CREATE }>
      <MenuItem
        title={ intl.formatMessage({ id: 'manage.cm.addComment' }) }
        icon={ <CommentsIcon /> }
        onClick={ () => {
          if (selectedVulnID) {
            if (isBulk) {
              dispatch(showBulkUpdateModal('comment', ''));
            } else {
              dispatch(redirectToManageDetail(selectedVulnID, 'comment'));
              dispatch(showContextMenu(false));
            }
          }
        } }
      />
    </WithPermission>
  );
};
